import { MARQUEE } from "@/content/site";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {MARQUEE.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-5xl font-light uppercase tracking-tight text-outline sm:text-7xl lg:text-8xl">{w}</span>
        <span className="h-3 w-3 rotate-45 bg-[#B8955F]" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <section data-testid="editorial-marquee" aria-label="Áreas de trabajo" className="overflow-hidden border-y border-[#1E2228]/10 bg-[#F6F4EF] py-10 sm:py-14">
      <div className="animate-marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </section>
  );
}
